const React = require("react");
const {ProgressBar} = require("react-bootstrap");

module.exports = () => {
    return <ProgressBar active now={100}/>;
};
